'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './admin-dashboard.routes';

export class AdminDashboardComponent {
  constructor(Config, EFormsService, SurveysService, SettingsService) {
    'ngInject';
    this.newsTypes = Config.getModuleConfig(Config.Modules.News).getTypes();
    this.defaultNewsType = Config.getModuleConfig(Config.Modules.News).getDefaultType();
    this.eventTypes = Config.getModuleConfig(Config.Modules.Calendar).getEventTypes();
    this.galleryTypes = Config.getModuleConfig(Config.Modules.Gallery).getTypes();

    this.rows = ["one", "two"];

    let docTypes = Config.getModuleConfig(Config.Modules.Document).getTypes();
    this.docPageTypes = Config.getModuleConfig(Config.Modules.Document).getPageCategories();

    this.persistOrder = event => {
      let sourceColumnIndex =  event.source.sortableScope.element[0].getAttribute('column-idx');
      let destColumnIndex = event.dest.sortableScope.element[0].getAttribute('column-idx');

      let sourceItemIndex = event.source.index;
      let destItemIndex = event.dest.index;

      console.log(sourceColumnIndex, destColumnIndex, sourceItemIndex, destItemIndex);

      /*
      this.ProjectService.patch({id: this.projectId}, [
        { "op": "move", "from": "/columns/"+sourceColumnIndex+"/items/"+sourceItemIndex, "path": "/columns/"+destColumnIndex+"/items/"+destItemIndex }
      ], _ => {
        this.refreshData();
      }, err => {
        console.log('Could not update project');
      });
      */
    };

    this.project = {
      columns: [{"name":"Not Started","color":"default","colorcode":"#777","_id":"5b27e4ba82047100a34a17f9","items":[{"_id":"5c7d548de1638a00a2fcaf50","title":"Another item with a little longer title","description":"Lorem ipsum dolor sit amet consequtor dolores est","__v":0,"meta":{"creationDate":"2019-03-04T16:38:37.789Z"},"highlight":true}]},{"name":"In Progress","color":"primary","colorcode":"#446e9b","_id":"5b27e4ba82047100a34a17f8","items":[{"_id":"5b27e4d282047100a34a17fa","title":"My first Project Item","__v":0,"progressTarget":8,"progressActual":10,"assignedTo":{"_id":"5ac9b7bd1ebe6f0cec92cf3c","salt":"7KN0CSmj28RVEUmYptUaAA==","provider":"local","firstName":"Conduu","middleName":"Management Suite","lastName":"Admin","email":"admin@example.com","password":"xJSKy786SsKGa1LhRQeVH99jAdPuUkUkPoQ/BqM3O0fQj7/9UNGvuz+o4sE2dcWtvTWTxUx+ZTm01nTv1V1aIQ==","__v":0,"role":["superadmin","admin","user"],"publicProfile":{"role":["superadmin","admin","user"],"name":"Admin"},"token":{"role":["superadmin","admin","user"],"_id":"5ac9b7bd1ebe6f0cec92cf3c"},"shortName":"Admin, C. M.","id":"5ac9b7bd1ebe6f0cec92cf3c"},"meta":{"creationDate":"2018-06-18T16:58:58.131Z"},"highlight":true}]},{"name":"Waiting","color":"warning","colorcode":"#f0ad4e","_id":"5b27e4ba82047100a34a17f7","items":[]}]
    };

    this.dragControlListeners = {
      accept: function (sourceItemHandleScope, destSortableScope) {
        return true;
      },
      itemMoved: this.persistOrder,
      orderChanged: this.persistOrder
    };

    /*

    SettingsService.getByName({name: 'account-request-config'}, setting => {
      this.accountRequestTypes = setting.data.types;
    }, _ => {
      this.accountRequestTypes = [];
    });

    this.widgets = [];

    SettingsService.getByName({name: 'admin-dashboard'}, widgets => {
      this.widgets = widgets.data;

      this.widgets.forEach(widget => {

        switch(widget.widget) {
          case "EFORM":
            EFormsService.query(data => {
              this.eforms = data;
            });
            break;
          case "SURVEY":
            SurveysService.query(data => {
              this.surveys = data;
            });
            break;
          case "RESERVATION":
            this.reservations = Config.getModuleConfig(Config.Modules.Reservation).getTypes();
            break;
          case "DIRECTORY":
            SettingsService.query(data => {
              this.directories = data
                .map(setting => {
                  return {
                    tags: setting.tags.map(tag => tag.text),
                    name: setting.name
                  }
                })
                .filter(setting => setting.tags.includes("directory"))
                .map(setting => {
                  return {
                    setting: setting.name,
                    name: setting.name.replace(/-/g,' ')
                  }
                })
            });
            break;
            case "FAQ":
            SettingsService.query(data => {
              this.faqs = data
                .map(setting => {
                  return {
                    tags: setting.tags.map(tag => tag.text),
                    name: setting.name
                  }
                })
                .filter(setting => setting.tags.includes("faq"))
                .map(setting => {
                  return {
                    setting: setting.name,
                    name: setting.name.replace(/-/g,' ')
                  }
                })
            });
            break;
        }

      });

    });

    if (this.docPageTypes && Object.keys(this.docPageTypes).length) {
      this.docPages = Object.keys(this.docPageTypes);
    } else {
      this.docPages = ["general"];
      this.docPageTypes = {'general': []};
      this.docPageTypes['general'] = docTypes;
    }

    */
  }
}

export default angular.module('coduuApp.admin.dashboard', [uiRouter])
  .config(routes)
  .component('adminDashboard', {
    template: require('./admin-dashboard.html'),
    controller: AdminDashboardComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/dashboard/admin-dashboard.component.js